import { GradeBandEnum } from "../models/constants"

export default class ResourceUtils {
    public static predefinedSubjectsList: any = [
        {
            colour: "#486CD8",
            subjectID: 8337,
            name: "Science",
        },
        {
            colour: "#6A1B9A",
            subjectID: 3026,
            name: "Social Studies",
        },
        {
            colour: "#B2528C",
            subjectID: 1184,
            name: "Mathematics",
        },
        {
            colour: "#D6383A",
            subjectID: 1880,
            name: "English Language Arts and Literacy",
        },
        {
            colour: "#262626",
            subjectID: 8353,
            name: "Engineering & Technology",
        },
        {
            colour: "#087B45",
            subjectID: 2806,
            name: "Health and Physical Education",
        },
        {
            colour: "#007B9B",
            subjectID: 2949,
            name: "Preschool",
        },
        {
            colour: "#60738A",
            subjectID: 6708,
            name: "Professional Development",
        },
        {
            colour: "#074D51",
            subjectID: 2663,
            name: "The Arts",
        },
        {
            colour: "#A31A51",
            subjectID: 6267,
            name: "World Languages",
        },
    ]

    public static getGradesDisplay(grades: string[]) {
        if (!grades) {
            return null
        }

        let gradesDisplay: string = ""

        const is13Plus = grades.length === 1 && grades[0] === GradeBandEnum.Band13Plus
        grades = grades.filter((g) => g !== GradeBandEnum.Band13Plus)
        const hasAllGrades =
            [
                GradeBandEnum.Band3to5,
                GradeBandEnum.Band6to8,
                GradeBandEnum.Band9to12,
            ].every((grade) => grades.includes(grade)) &&
            (grades.includes(GradeBandEnum.BandPreKtoK) || grades.includes(GradeBandEnum.BandKto2))

        if (is13Plus) {
            gradesDisplay = null
        } else if (hasAllGrades) {
            gradesDisplay = "All"
        } else {
            gradesDisplay = grades.join(", ")
        }

        return gradesDisplay
    }

    public static getMediaTypesDisplay(mediaTypes: { [mediaType: string]: number }): string {
        return Object.keys(mediaTypes)
            .map((mediaType) => `${mediaType} (${mediaTypes[mediaType]})`)
            .join(", ")
    }

    public static getResourcesByLanguage(languages: { [language: string]: number }): string {
        let resByLanguageText = Object.keys(languages)
            .map((language) => `Resources in ${language} (${languages[language]})`)
            .join(", ")
        return resByLanguageText ? ", " + resByLanguageText : ""
    }

    public static getResourceTypesDisplay(
        mediaTypes: { [mediaType: string]: number },
        grades: string[],
        resources_by_language: { [language: string]: number }
    ): string {
        let displayText = ""
        const mediaDisplay = ResourceUtils.getMediaTypesDisplay(mediaTypes)
        const gradeDisplay = ResourceUtils.getGradesDisplay(grades)
        if (mediaDisplay && gradeDisplay) {
            displayText = `${mediaDisplay} for Grades ${gradeDisplay}`
        }
        const resourcesByLanguage = ResourceUtils.getResourcesByLanguage(resources_by_language)
        if (resourcesByLanguage) {
            displayText = displayText + resourcesByLanguage
        }
        return displayText
    }

    public static getPremiumCollectionSlug() {
        if (window.location.href.split("/").length != 8) {
            return "" // False
        } else {
            return window.location.href.split("/").reverse().slice(1, 2).toString()
        }
    }
}
